import { useMutation } from "app/hooks/root-contract/mutation/use-mutation";
import { BigNumberish } from "ethers";
import stakingContract from "services/staking.contract";
import { useChainId } from "wagmi";

export const useReStakeMutation = () => {
  const chainId = useChainId();
  const reStakeMutation = async ({ pid }: { pid: BigNumberish }) => {
    return await stakingContract.reStakePopulate({
      address: process.env.REACT_APP_STAKING_CONTRACT_ADDR,
      chainId: chainId,
      pid,
    });
  };
  return useMutation(reStakeMutation);
};
